import { ref, VueElement } from "vue";
import FormError from "@/ts/form/errors.vue";

interface ParsedError {
    status: number;
    errors: Array<{
        message: string;
        field: string;
        indexes: [];
        params: [];
    }>;
}

function useErrors() {
    const errors = ref();

    function parse(error: any) {
        if (error.body) {
            if (error.body.data && error.body.data.status && error.body.data.status === "validation_failed") {
                errors.value = {
                    status: error.body.status,
                    errors: [
                        {
                            message: error.body.data.message,
                            field: "",
                            indexes: [],
                            params: [],
                        },
                    ],
                };
            } else {
                errors.value = error.body;
            }
        } else if (error.response) {
            errors.value = error.response.data as ParsedError;
        } else if (error.request) {
            console.log(error.request);
        } else {
            console.log("Error", error.message);
        }
    }

    function get(): ParsedError | undefined {
        return errors.value;
    }

    function any(): boolean {
        if (!errors.value) {
            return true;
        }

        return errors.value.length > 0;
    }

    function render(): VueElement {
        return FormError;
    }

    return { parse, get, any, render };
}

function isObj(a: any) {
    if (!!a && a.constructor === Object) {
        return true;
    }
    return false;
}

function _st(z: string, g: string) {
    return "" + (g != "" ? "[" : "") + z + (g != "" ? "]" : "");
}

function queryFromObject(params: any, skipobjects?: any, prefix?: any) {
    if (skipobjects === void 0) {
        skipobjects = false;
    }
    if (prefix === void 0) {
        prefix = "";
    }
    var result = "";
    if (typeof params != "object") {
        return prefix + "=" + encodeURIComponent(params) + "&";
    }
    for (var param in params) {
        var c = "" + prefix + _st(param, prefix);
        if (isObj(params[param]) && !skipobjects) {
            result += queryFromObject(params[param], false, "" + c);
        } else if (Array.isArray(params[param]) && !skipobjects) {
            params[param].forEach(function (item: object, ind: number) {
                result += queryFromObject(item, false, c + "[" + ind + "]");
            });
        } else {
            result += c + "=" + encodeURIComponent(params[param]) + "&";
        }
    }
    return result;
}

export { useErrors, queryFromObject };
